export const ADMIN_SIDEBAR_COLLAPSED_KEY = 'sb.adminSidebar.collapsed';

export function readAdminSidebarCollapsed() {
  try {
    return window.localStorage.getItem(ADMIN_SIDEBAR_COLLAPSED_KEY) === '1';
  } catch {
    return false;
  }
}

export function writeAdminSidebarCollapsed(collapsed) {
  try {
    window.localStorage.setItem(ADMIN_SIDEBAR_COLLAPSED_KEY, collapsed ? '1' : '0');
  } catch {
    // Ignore storage failures; the toggle still works for this session.
  }
}
